import React from 'react';

import {getAbilityMod, getSaveMod} from '../render-helpers';
import {cls} from '../utils';

import css from './monster-block-table.module.css';

type Props = {
	params: Record<string, number>;
	saves?: Array<{type: string; value: string}>;
};

type MonsterBlock = {
	params: Record<string, number>;
	saves?: Array<{type: string; value: string}>;
	paramName: string;
	line?: number;
};

const Abilities: Record<string, string> = {
	Str: 'Сил',
	Int: 'Инт',
	Dex: 'Лвк',
	Wis: 'Мдр',
	Con: 'Вын',

	Cha: 'Хар',
};

const MonsterBlock: React.FC<MonsterBlock> = ({paramName, params, saves, line}) => {
	return (
		<tr className={line === 1 ? css.firstLine : css.secondLine}>
			<td className={cls(css.stat, css.statName)}>{Abilities[paramName]}</td>
			<td className={css.stat}>{params[paramName.toLowerCase()]}</td>
			<td className={css.mod}>{getAbilityMod(params[paramName.toLowerCase()])}</td>
			<td className={css.mod}>
				{getSaveMod(params[paramName.toLowerCase()], saves?.find((save) => save.type === paramName)?.value)}
			</td>
		</tr>
	);
};

export const MonsterBlockTable: React.FC<Props> = ({saves, params}) => {
	const abilities = [
		['Str', 'Int'],
		['Dex', 'Wis'],
		['Con', 'Cha'],
	];

	return (
		<div className={css.block}>
			{Array(3)
				.fill(0)
				.map((_, index) => {
					const abilitiesPair = abilities[index];
					return (
						<table className={css.column} key={index}>
							<thead>
								<tr>
									<td></td>
									<td></td>
									<td className={css.header}>МОД</td>
									<td className={css.header}>ИСП</td>
								</tr>
							</thead>
							<tbody>
								{abilitiesPair.map((ability, abilityIndex) => (
									<MonsterBlock
										params={params}
										saves={saves}
										paramName={ability}
										key={ability}
										line={abilityIndex + 1}
									/>
								))}
							</tbody>
						</table>
					);
				})}
		</div>
	);
};
